import { IntersectionObserver } from './intersectionObserver/index';
import AdapterConfig from './utils/AdapterConfig';
import TraceInit from './TraceInit';

class TraceIo extends IntersectionObserver {
  // 重写了父类的方法
  exposureResult = (exposureDatas) => {
    super.exposureResult(exposureDatas);

    // 埋点上报处理
    exposureDatas.forEach((entry, index) => {
      const { isInsecting, extraData, scope } = entry;
      const { traceId, traceData, scmv2, pageName, statSend } = extraData;

      if (isInsecting) {
        // 根据traceId去config中获取数据
        const operation = AdapterConfig.getTraceOperation(traceId);

        if (operation?.includes('visible')) {
          const spm = AdapterConfig.getSpm(statSend, { b, c, d });
          const parsedData = AdapterConfig.getTraceData(pageName, traceId, {
            traceData,
            type: 'visible',
          });
          const { b, c, d, iid } = parsedData;

          if (TraceInit.getInstance().isSpm) {
            statSend && statSend.visible(c, iid, { spm, scmv2 });
          } else {
            statSend && statSend.visible(parsedData);
          }

          // console.log('===子类 曝光上报', scope, b, c, d);
        }
      }
    });
  };
}

export default TraceIo;
